// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import SidebarAd from './SidebarAd';

const BlogHeaderAd = ({ onAvailabilityChange }) => {
  return <SidebarAd variant="blog-header" onAvailabilityChange={onAvailabilityChange} />;
};

export default BlogHeaderAd;
